export default {
  back: {
    picture:
      "https://d1b4ki36u68t9l.cloudfront.net/surfaces/a84c015426772acfdbb0df28857c68c7_a48a07b1d8ae1ea9e7d3f63c4f21a9332ce2.jpg",
    ppi: 130.62,
    bounding_box: { top: 2028.0, left: 1334.0, width: 1449.0, height: 1828.0 },
    surface_location_offset: {
      top_x: 2058.0,
      top_y: 1577.0,
      bottom_x: 2058.0,
      bottom_y: 2028.0
    },
    is_dark: false,
    is_youth: false
  },
  front: {
    picture:
      "https://d1b4ki36u68t9l.cloudfront.net/surfaces/1dc4f3c3672e233b1bac73a07e61c73d_5589000e149a78eb77b8554c98987d9e3a8a.jpg",
    ppi: 112.83,
    bounding_box: { top: 1933.0, left: 1323.0, width: 1252.0, height: 1579.0 },
    surface_location_offset: {
      top_x: 1949.0,
      top_y: 1689.0,
      bottom_x: 1949.0,
      bottom_y: 1933.0
    },
    is_dark: false,
    is_youth: false
  },
  front_left_chest: {
    picture:
      "https://d1b4ki36u68t9l.cloudfront.net/surfaces/1dc4f3c3672e233b1bac73a07e61c73d_5589000e149a78eb77b8554c98987d9e3a8a.jpg",
    ppi: 112.83,
    bounding_box: { top: 2042.0, left: 2066.0, width: 451.0, height: 451.0 },
    surface_location_offset: {
      top_x: 2291.0,
      top_y: 1452.0,
      bottom_x: 2291.0,
      bottom_y: 2042.0
    },
    is_dark: false,
    is_youth: false
  }
};
